/** Prefijo de las claves de localStorage con las métricas de cartera del broker. */
export const WALLET_METRICS_PREFIX = 'brokWalletMetrics';

export interface WalletMetrics {
  valorLiquidativo: number;
  riesgomaximo: number;
  riesgoActual: number;
  margen: number;
  controlMarginCall: number;
}

/** Clave por cartera para no mezclar métricas entre carteras/pestañas. */
export function walletMetricsKey(idcartera: number | string): string {
  return `${WALLET_METRICS_PREFIX}_${idcartera}`;
}
